import { render, staticRenderFns } from "./SheetLecture.vue?vue&type=template&id=5f99cab5"
import script from "./SheetLecture.vue?vue&type=script&lang=js"
export * from "./SheetLecture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports